import { Button } from "@mui/material";
import { useEffect, useState } from "react";
import './NavbarSearchTestPageElementCss/SearchModal.css';
import { useNavigate } from "react-router-dom";
import { createPortal } from "react-dom";
import { useCart } from "../../Contexts/Cart.contexts";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useRef } from "react";

const SERVICE_API = "https://rbdiagnostic.com:3000/RBD/Service";
const PACKAGE_API = "https://rbdiagnostic.com:3000/RBD/OnlyPackageNew";

export default function SearchModal({ onClose }) {
  const [activeTab, setActiveTab] = useState("tests");
  const [searchKey, setSearchKey] = useState("");
  const [testList, setTestList] = useState([]);
  const [packageList, setPackageList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [expandedTestId, setExpandedTestId] = useState(null);
  const [expandedPackageId, setExpandedPackageId] = useState(null);
  const inputRef = useRef(null);

  const navigate = useNavigate();
  const { cartItems, addToCart, removeFromCart } = useCart();

  /* 🔒 Lock background scroll */
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = "auto");
  }, []);

  /* 🔄 Fetch data */
  useEffect(() => {
    fetchAllData();
  }, []);

  const fetchAllData = async () => {
    try {
      setLoading(true);

      const payload = {
        RBAuthKey: "RBDWAh!Q1s74e",
        Center_ID: "",
        search_key: "",
      };

      const [testRes, pkgRes] = await Promise.all([
        fetch(SERVICE_API, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }),
        fetch(PACKAGE_API, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ search_key: "" }),
        }),
      ]);

      const testData = await testRes.json();
      const pkgData = await pkgRes.json();

      setTestList(testData?.data || []);
      setPackageList(pkgData?.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  /* 🔍 Filters */
  const filteredTests = testList.filter(
    (t) =>
      !searchKey ||
      t.service_name?.toLowerCase().includes(searchKey.toLowerCase()),
  );

  const filteredPackages = packageList.filter(
    (pkg) =>
      !searchKey ||
      pkg?.list?.some((t) =>
        (typeof t === "string" ? t : t?.service_name || "")
          .toLowerCase()
          .includes(searchKey.toLowerCase()),
      ),
  );

  useEffect(() => {
    if (
      searchKey &&
      (filteredTests.length > 0 || filteredPackages.length > 0)
    ) {
      const timer = setTimeout(() => {
        setSearchKey("");
        inputRef.current?.focus();
      }, 600); 

      return () => clearTimeout(timer);
    }
  }, [filteredTests, filteredPackages]);

  const noResultsFound =
    searchKey && filteredTests.length === 0 && filteredPackages.length === 0;

  /* 🛒 Toggle Cart */
  // const toggleCart = (item, type) => {
  //   const exists = cartItems.some((c) => c.id === item.service_id);

  //   if (exists) {
  //     removeFromCart(item.service_id);
  //   } else {
  //     addToCart({
  //       id: item.service_id,
  //       product: item.service_name,
  //       price: Number(item.price),
  //       quantity: 1,
  //       type,
  //     });
  //   }
  // };

  const toggleCart = (item, type) => {
    setSearchKey("");
    inputRef.current?.focus();

    const exists = cartItems.some((c) => c.id === item.service_id);

    if (exists) {
      removeFromCart(item.service_id);
    } else {
      addToCart({
        id: item.service_id,
        product: item.service_name,
        price: Number(item.price),
        quantity: 1,
        type,
      });
    }
  };

  const totalAmount = cartItems.reduce(
    (sum, i) => sum + i.price * (i.quantity || 1),
    0,
  );

  const modalRoot = document.getElementById("modal-root");
  if (!modalRoot) return null;

  return createPortal(
    <div className="modal-overlays" onClick={onClose}>
      <div className="search-modal" onClick={(e) => e.stopPropagation()}>
        {/* SEARCH */}
        <div className="search-header">
          <span className="back" onClick={onClose}>
            ←
          </span>
          {/* <input
            autoFocus
            placeholder="Search tests or packages"
            value={searchKey}
            onChange={(e) => setSearchKey(e.target.value)}
          /> */}
          <input
            ref={inputRef}
            autoFocus
            placeholder="Search tests or packages"
            value={searchKey}
            onChange={(e) => setSearchKey(e.target.value)}
          />

          {searchKey && (
            <span className="clear-btn" onClick={() => setSearchKey("")}>
              ✕
            </span>
          )}
        </div>

        {/* TABS */}
        <div className="tabs">
          {/* <button
            className={activeTab === "tests" ? "active" : ""}
            onClick={() => setActiveTab("tests")}
          >
            Tests
          </button>
          <button
            className={activeTab === "packages" ? "active" : ""}
            onClick={() => setActiveTab("packages")}
          >
            Packages
          </button> */}

          <button
            className={activeTab === "tests" ? "active" : ""}
            onClick={() => {
              setActiveTab("tests");
              setSearchKey("");
              inputRef.current?.focus();
            }}
          >
            Tests
          </button>

          <button
            className={activeTab === "packages" ? "active" : ""}
            onClick={() => {
              setActiveTab("packages");
              setSearchKey("");
              inputRef.current?.focus();
            }}
          >
            Packages
          </button>
        </div>

        {/* CONTENT */}
        <div className="content">
          {!loading && noResultsFound && (
            <div className="no-results">
              <h3>No results found!</h3>
              <p>Can’t find the test or package?</p>
              <div className="no-results-buttons">
                <button onClick={() => navigate("/test-packages")}>
                  View All Tests
                </button>
                <button onClick={() => navigate("/service/OurPackagesPage")}>
                  View Health Packages
                </button>
              </div>
            </div>
          )}

          {loading && <p>Loading...</p>}

          {/* TESTS */}
          {!loading &&
            activeTab === "tests" &&
            filteredTests.map((t) => (
              <ServiceCard
                key={t.service_id}
                item={t}
                title={t.service_name}
                subtitles={`🕒 Reports in ${t.ReportTimeInDays} days`}
                price={t.price}
                added={cartItems.some((i) => i.id === t.service_id)}
                onClick={() => toggleCart(t, "test")}
                isExpanded={expandedTestId === t.service_id}
                onToggleExpand={() =>
                  setExpandedTestId(
                    expandedTestId === t.service_id ? null : t.service_id,
                  )
                }
              />
            ))}

          {/* PACKAGES */}
          {!loading &&
            activeTab === "packages" &&
            filteredPackages.map((p) => (
              <ServiceCard
                key={p.service_id}
                item={p}
                title={p.service_name}
                subtitles={`${p.list?.length || 0} Tests Included`}
                price={p.price}
                added={cartItems.some((i) => i.id === p.service_id)}
                onClick={() => toggleCart(p, "package")}
                isPackage
                isExpanded={expandedPackageId === p.service_id}
                onToggleExpand={() =>
                  setExpandedPackageId(
                    expandedPackageId === p.service_id ? null : p.service_id,
                  )
                }
              />
            ))}
        </div>

        {/* FOOTER */}
        <div className="footers">
          <strong>
            ₹ {totalAmount} ({cartItems.length} Items)
          </strong>
          <button
            className="proceed-btns"
            disabled={cartItems.length === 0}
            onClick={() => {
              onClose();
              navigate("/cart");
            }}
          >
            Proceed
          </button>
        </div>
      </div>
    </div>,
    modalRoot,
  );
}

/* 🧩 SERVICE CARD */
function ServiceCard({
  title,
  subtitles,
  price,
  added,
  onClick,
  item,
  isPackage,
  isExpanded,
  onToggleExpand,
}) {
  return (
    <div className="card">
      <div className="card-top">
        <h3>{title}</h3>
        <button className={`add-btn ${added ? "added" : ""}`} onClick={onClick}>
          {added ? "Added" : "+ Add to Cart"}
        </button>
      </div>

      <p className="subtitles">{subtitles}</p>
      <div className="price">₹{price}</div>

      <div className="view-details-link" onClick={onToggleExpand}>
        <span>{isExpanded ? "Hide Details" : "View Details"}</span>
        <ExpandMoreIcon
          className={`expand-icon ${isExpanded ? "expanded" : ""}`}
        />
      </div>

      {/* ✅ TEST DETAILS */}
      {isExpanded && !isPackage && (
        <div className="expanded-details">
          <div>
            <strong>Department:</strong> {item.Department}
          </div>
          {item.SampleName && (
            <div>
              <strong>Sample:</strong> {item.SampleName}
            </div>
          )}
          {item.service_preperation && (
            <div>
              <strong>Preparation:</strong> {item.service_preperation}
            </div>
          )}
          {item.ReportTimeInDays && (
            <div>
              <strong>Report Time:</strong> {item.ReportTimeInDays} days
            </div>
          )}
          {item.NoOfParams && (
            <div>
              <strong>No. of Parameters:</strong> {item.NoOfParams}
            </div>
          )}
        </div>
      )}

      {/* ✅ PACKAGE TEST LIST */}
      {isPackage && isExpanded && (
        <div className="package-test-list">
          <h4>Test list included in this package</h4>
          {item.list?.map((test) => (
            <div key={test.service_id} className="package-test-item">
              {test.service_name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
